import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import { brandConfig } from "src/config/brand";

const SERVICE_NAME = brandConfig.name;
const COMPANY_NAME = brandConfig.name;

export const termsOfService = [
  {
    title: "제1조 (목적)",
    content: `이 약관은 ${COMPANY_NAME}(이하 "회사")이 제공하는 부동산 데이터 분석 서비스 ${SERVICE_NAME}(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.`,
  },
  {
    title: "제2조 (용어의 정의)",
    content: `① "서비스"란 회사가 제공하는 부동산 시세, 매매지수, 입주물량 등의 데이터 분석 및 시각화 서비스를 말합니다.
② "이용자"란 이 약관에 따라 회사가 제공하는 서비스를 이용하는 회원을 말합니다.
③ "회원"이란 회사에 개인정보를 제공하고 회원 등록을 한 자로서, 서비스를 이용할 수 있는 자를 말합니다.`,
  },
  {
    title: "제3조 (약관의 효력 및 변경)",
    content: `① 이 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다.
② 회사는 필요한 경우 관련 법령에 위배되지 않는 범위 내에서 이 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항을 통해 공지합니다.
③ 변경된 약관에 동의하지 않는 이용자는 서비스 이용을 중단하고 탈퇴할 수 있습니다.`,
  },
  {
    title: "제4조 (서비스의 제공)",
    content: `① 회사는 다음과 같은 서비스를 제공합니다.
  1. 부동산 시세 및 매매지수 분석
  2. 지역별 부동산 시장 데이터 시각화
  3. 아파트 매물 및 거래 데이터 조회
  4. 기타 부동산 데이터 분석 관련 서비스
② 회사는 서비스의 내용을 변경하거나 중단할 수 있으며, 이 경우 사전에 공지합니다.`,
  },
  {
    title: "제5조 (회원 가입 및 탈퇴)",
    content: `① 회원 가입은 이용자가 약관에 동의하고, 회사가 정한 가입 양식에 따라 정보를 기입한 후 이메일 인증을 완료하면 성립됩니다.
② 회원은 언제든지 서비스 내에서 탈퇴를 요청할 수 있으며, 회사는 즉시 처리합니다.
③ 회원 탈퇴 시 관련 법령에 따라 일정 기간 개인정보를 보관할 수 있습니다.`,
  },
  {
    title: "제6조 (이용자의 의무)",
    content: `① 이용자는 서비스 이용 시 관련 법령, 약관, 이용안내 등을 준수해야 합니다.
② 이용자는 타인의 정보를 도용하거나 허위 정보를 등록해서는 안 됩니다.
③ 이용자는 서비스를 통해 얻은 정보를 회사의 사전 동의 없이 상업적으로 이용하거나 제3자에게 제공해서는 안 됩니다.`,
  },
  {
    title: "제7조 (면책 조항)",
    content: `① 서비스에서 제공하는 모든 부동산 데이터 및 분석 결과는 참고 목적으로만 제공되며, 투자 판단의 근거로 사용함에 따른 손실에 대해 회사는 책임을 지지 않습니다.
② 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등 불가항력적인 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.
③ 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.
④ 서비스에서 제공하는 시세, 지수, 통계 등의 데이터는 외부 기관(KB부동산, 국토교통부 등)의 원본 데이터에 기반하며, 데이터의 정확성을 보증하지 않습니다.`,
  },
  {
    title: "제8조 (환불 정책)",
    content: `① 유료 서비스의 이용 기간은 결제 완료 즉시 시작되거나 기존 잔여 이용 기간에 연장되며, 실제 접속 또는 기능 사용 여부와 관계없이 경과합니다.
② 환불 시 결제 완료일부터 환불 요청일까지 경과한 이용 기간에 해당하는 금액을 공제한 후 잔액을 환불합니다. 기존 잔여 이용 기간 뒤에 추가된 이용권으로서 아직 이용 기간이 시작되지 않은 경우에는 해당 이용권의 결제 금액을 환불합니다.
③ 환불 요청은 서비스 내 문의 채널을 통해 접수할 수 있으며, 접수일로부터 영업일 기준 3일 이내에 처리됩니다.
④ 청약철회 및 환불에 관하여 관련 법령에 별도의 규정이 있는 경우에는 해당 법령을 우선 적용합니다.`,
  },
  {
    title: "제9조 (분쟁 해결)",
    content: `① 회사와 이용자 간 발생한 분쟁은 상호 협의하여 해결합니다.
② 협의가 이루어지지 않을 경우 관할 법원에 소를 제기할 수 있습니다.`,
  },
];

export const privacyPolicy = [
  {
    title: "제1조 (개인정보의 수집 항목 및 방법)",
    content: `① 회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.
  1. 필수 항목: 이메일 주소, 비밀번호, 닉네임
  2. 소셜 로그인 시: 소셜 계정 고유 ID, 닉네임, 제공에 동의한 경우 이메일 주소
② 수집 방법: 회원 가입 시 이용자가 직접 입력, 소셜 로그인(카카오, 네이버) 연동 시 자동 수집`,
  },
  {
    title: "제2조 (개인정보의 수집 및 이용 목적)",
    content: `회사는 수집한 개인정보를 다음의 목적으로 이용합니다.
  1. 회원 식별 및 가입 의사 확인
  2. 서비스 제공 및 이용 권한 관리
  3. 고객 문의 대응 및 공지사항 전달
  4. 서비스 개선을 위한 통계 분석`,
  },
  {
    title: "제3조 (개인정보의 보유 및 이용 기간)",
    content: `① 회사는 회원 탈퇴 시 지체 없이 개인정보를 파기합니다.
② 단, 관련 법령에 따라 아래와 같이 보관할 수 있습니다.
  1. 계약 또는 청약 철회 등에 관한 기록: 5년 (전자상거래법)
  2. 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)
  3. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)
  4. 웹사이트 방문 기록: 3개월 (통신비밀보호법)`,
  },
  {
    title: "제4조 (개인정보의 제3자 제공)",
    content: `회사는 이용자의 개인정보를 원칙적으로 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
  1. 이용자가 사전에 동의한 경우
  2. 법률에 특별한 규정이 있거나 법적 의무를 준수하기 위해 필요한 경우`,
  },
  {
    title: "제5조 (개인정보의 파기 절차 및 방법)",
    content: `① 파기 절차: 보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.
② 파기 방법: 전자적 파일은 복구 불가능한 방법으로 삭제하고, 종이 문서는 분쇄하거나 소각합니다.`,
  },
  {
    title: "제6조 (이용자의 권리와 행사 방법)",
    content: `① 이용자는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있습니다.
② 이용자는 회원 탈퇴를 통해 개인정보 처리에 대한 동의를 철회할 수 있습니다.
③ 개인정보 관련 문의는 서비스 내 문의 채널을 통해 접수할 수 있습니다.`,
  },
  {
    title: "제7조 (개인정보의 안전성 확보 조치)",
    content: `회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
  1. 비밀번호 암호화 저장
  2. 개인정보 접근 권한 관리
  3. SSL/TLS 암호화 통신
  4. 접근 기록 보관 및 위·변조 방지`,
  },
  {
    title: "제8조 (개인정보 보호책임자)",
    content: `회사는 개인정보 처리에 관한 업무를 총괄하는 개인정보 보호책임자를 지정하고 있습니다. 개인정보 관련 문의는 서비스 내 문의 채널을 통해 접수해 주시기 바랍니다.`,
  },
];

export const TermsSectionList = ({ sections }) => (
  <>
    {sections.map((section, index) => (
      <Box
        key={index}
        sx={{ mb: 2 }}
      >
        <Typography
          variant="subtitle2"
          sx={{ mb: 0.5 }}
        >
          {section.title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: "pre-line" }}
        >
          {section.content}
        </Typography>
      </Box>
    ))}
  </>
);

export const TermsDialog = ({ open, onClose, onAgree, type }) => {
  const isTerms = type === "terms";
  const title = isTerms ? "서비스 이용약관" : "개인정보처리방침";
  const sections = isTerms ? termsOfService : privacyPolicy;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>{title}</DialogTitle>
      <Divider />
      <DialogContent>
        <TermsSectionList sections={sections} />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          onClick={onClose}
          color="inherit"
        >
          닫기
        </Button>
        <Button
          onClick={onAgree}
          variant="contained"
        >
          동의
        </Button>
      </DialogActions>
    </Dialog>
  );
};
